import { Injectable } from "@angular/core";
import { AuthenticationService } from "projects/lib_authentication/src/public-api";
import { ApplicationSettings } from 'projects/lib_config/src/public-api';
import { ScriptInjectorService } from "./script-injector.service";

declare const window: Window;
declare const _satellite: any;
declare global {
  interface Window {
    digitalData: any;
  }
}

@Injectable({
  providedIn: 'root'
})

export class AnalyticsService {

  private userId: string;

  constructor(
    private scriptInjectorService: ScriptInjectorService,
    private appSettings: ApplicationSettings,
    private authenticationService: AuthenticationService) { }

  initAdobeLaunchDataLayer() {
    try {
      this.authenticationService.getAuthenticadedUserObservable().subscribe(user => {
        if (user) {
          const isInternalUser = user.preferredUsername.toLocaleLowerCase().endsWith('@deloitte.com');
          this.userId = user.preferredUsername.split('@')[0];

          (window as Window).digitalData = {
            page: {
              pageInfo: { pageName: "page_name" },
              category: { primaryCategory: "site_section" }
            },
            user: [{
              profile: [{
                profileInfo: { userName: isInternalUser ? this.userId : '' }
              }]
            }]
          };
          console.info('Analytics data layer initiated..');
        }
      });
    } catch (e) {
      console.error('Error while initializing analytics data', e);
    }
  }

  async injectAdobeLaunchScript() {
    try {
      await this.scriptInjectorService.load('launch', this.appSettings.analyticsScriptSrc);
      _satellite.pageBottom();

      console.info('Analytics script loaded..');
    } catch (e) {
      console.error('Error while loading analytics script', e);
    }
  }

  trackPage(section: string, name: string) {
    if (this.appSettings.enableAnalytics) {
      try {
        (window as Window).digitalData.page.pageInfo.pageName = name;
        (window as Window).digitalData.page.category.primaryCategory = section;
        _satellite.track('page_load');
      } catch (e) {
        console.error('Error while calling analytics tracking', e);
      }
    }
  }
}
